module.exports = __webpack_public_path__ + "img/td-6.cceb39c2.jpg";